module.exports = __webpack_public_path__ + "img/pause.7df710bc.svg";